import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { Nullable } from '@client/core/data/types';

/**
 * See ProjectFlipAnalysisResource.php.
 */
export class ProjectFlipAnalysis {
  constructor(
    public readonly afterRepairValue: Nullable<number>,
    public readonly purchasePrice: Nullable<number>,
    public readonly repairCosts: Nullable<number>,
    public readonly fixedCosts: Nullable<number>,
    public readonly financingCosts: Nullable<number>,
    public readonly calculatedProfit: Nullable<number>,
    public readonly cashNeeded: Nullable<number>,
    public readonly totalUpfrontCosts: Nullable<number>,
    public readonly totalFunding: Nullable<number>,
    public readonly holdingCostsMonths: Nullable<number>,
    public readonly annualizedCocrPercentage: Nullable<number>,
    public readonly seventyPercentRule: number,
  ) {}
}

defineTransform(ProjectFlipAnalysis, (json, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),

    // Backend sends 85.6% as float 85.6. But frontend wants 0.856 for that number.
    seventyPercentRule: json.seventy_percent_rule / 100,
  };
});
